import PropTypes from 'prop-types';

const propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    slug: PropTypes.string,
    organization: PropTypes.string,
    position: PropTypes.string,
    company: PropTypes.shape({
      name: PropTypes.string,
      activePartnership: PropTypes.bool,
    }),
    profilePictureUrl: PropTypes.string,
    blurb: PropTypes.string,
    activePartnership: PropTypes.shape({
      id: PropTypes.number,
    }),
    areasOfExpertise: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      slug: PropTypes.string,
      name: PropTypes.string,
    })),
    canPostWires: PropTypes.bool,
  }).isRequired,
  wire: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  investorTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ),
  alt: PropTypes.string,
  isProfileFollowedByCurrentUser: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool,
  isOfCurrentUser: PropTypes.bool,
  isOnWireSide: PropTypes.bool,
  isOnContributorSearchResultPage: PropTypes.bool,
  onUnfollow: PropTypes.func,
  clickDataAttributes: PropTypes.shape({}),
  followEventName: PropTypes.string,
  unfollowEventName: PropTypes.string,
};

const defaultProps = {
  alt: null,
  wire: null,
  investorTypes: [],
  isExpanded: false,
  isOfCurrentUser: false,
  isOnWireSide: false,
  isOnContributorSearchResultPage: false,
  onUnfollow: null,
  clickDataAttributes: null,
  followEventName: 'follow_profile',
  unfollowEventName: 'unfollow_profile',
};

const isContactable = props => {
  const { isOfCurrentUser, wire, profile } = props;
  const { canPostWires, activePartnership, company } = profile || {};
  const contactable = canPostWires
    && !isOfCurrentUser
    && wire
    && (activePartnership || (company && company.activePartnership));
  return contactable;
};

export {
  isContactable,
  defaultProps,
  propTypes,
};
